var React = require('react');

function MenusDropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 17H19M9 12H19M9 7H19M5.00195 17V17.002L5 17.002V17H5.00195ZM5.00195 12V12.002L5 12.002V12H5.00195ZM5.00195 7V7.002L5 7.00195V7H5.00195Z","stroke":"#10428B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MenusDropdown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MenusDropdown;

MenusDropdown.default = MenusDropdown;
